import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import AxiosUrl from "../../AxiosUrl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import EditIcon from "@mui/icons-material/Edit";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import WcIcon from "@mui/icons-material/Wc";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import PaymentIcon from "@mui/icons-material/Payment";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import VideocamIcon from "@mui/icons-material/Videocam";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import EmailIcon from "@mui/icons-material/Email";
import DescriptionIcon from "@mui/icons-material/Description";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import BlockIcon from "@mui/icons-material/Block";
import Chip from "@mui/material/Chip";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import MoneyIcon from "@mui/icons-material/Money";
import LockIcon from "@mui/icons-material/Lock";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import GroupsIcon from "@mui/icons-material/Groups";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import LinkIcon from "@mui/icons-material/Link";
import AndroidIcon from "@mui/icons-material/Android";
import DevicesIcon from "@mui/icons-material/Devices";
import CampaignIcon from "@mui/icons-material/Campaign";
import PauseIcon from "@mui/icons-material/Pause";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import "./EditUserModal.css";

function UpdateUser({ setOpenModal, data, setRefresh }) {
  const uid = localStorage.getItem("id");
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState(data.username || "");
  const [mobile, setMobile] = useState(data.mobile || "");
  const [email, setEmail] = useState(data.email || "");
  const [mobileVerified, setMobileVerified] = useState(data.Mob_Verify || false);
  const [gender, setGender] = useState(data.gender || "Male");
  const [idVerified, setIdVerified] = useState(data.Id_Verify || false);
  const [accountType, setAccountType] = useState(() => {
    const validAccountTypes = ["General", "Premium", "VIP", "Islamic"];
    return validAccountTypes.includes(data.accountType) ? data.accountType : "General";
  });
  const [accountFor, setAccountFor] = useState(data.accountFor || "Self");
  const [askPayment, setAskPayment] = useState(data.AskPayment || false);
  const [isPhotoVerified, setIsPhotoVerified] = useState(data.IsPhoto || false);
  const [isVideoVerified, setIsVideoVerified] = useState(data.IsVideo || false);
  const [isPhotoApproved, setIsPhotoApproved] = useState(data.isPhotoApproved || false);
  const [setCv, setSetCv] = useState(data.SetCV || false);
  const [status, setStatus] = useState(data.userStatus === 0 ? "Active" : "Deactive");
  const [inactiveReason, setInactiveReason] = useState(() => {
    if (data.inactiveReason) {
      return data.inactiveReason;
    } else if (data.inactiveReason && data.inactiveReason.reason) {
      return data.inactiveReason.reason;
    } else if (data.inactiveReason && typeof data.inactiveReason === 'string') {
      return data.inactiveReason;
    }
    return "";
  });
  const [balance, setBalance] = useState(data.Balance || 0);
  const [affBalance, setAffBalance] = useState(data.AffBalance || 0);
  const [emailVerified, setEmailVerified] = useState(data.Email_Verify || false);
  const [isCvApproved, setIsCvApproved] = useState(data.isCvApproved || false);
  const [promote, setPromote] = useState(data.promote || false);
  const [lock, setLock] = useState(data.lock || false);
  const [isAdmin, setIsAdmin] = useState(data.IsAdmin || false);
  const [isTeam, setIsTeam] = useState(data.IsTeam || false);
  const [onlyAff, setOnlyAff] = useState(data.OnlyAff || false);
  const [adminType, setAdminType] = useState(data.AdminType || "");
  const [uniqueId, setUniqueId] = useState(data.UniqueId || "");
  const [affLink, setAffLink] = useState(data.AffLink || "");
  const [affiliateId, setAffiliateId] = useState(data.affiliateId || "");
  const [expoToken, setExpoToken] = useState(data.ExpoToken || "");
  const [androidId, setAndroidId] = useState(data.androidId || "");
  const [osName, setOsName] = useState(data.osName || "");
  const [osBuildId, setOsBuildId] = useState(data.osBuildId || "");
  const [source, setSource] = useState(data.source || "");
  
  const isMobile = useMediaQuery("(max-width:768px)");

  // Video player state variables
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [videoTime, setVideoTime] = useState('0:00');
  const videoRef = React.useRef(null);
  
  // Add video progress state
  const [progress, setProgress] = useState(0);

  const handleClose = () => {
    // Stop video playback before closing modal
    if (videoRef.current) {
      try {
        videoRef.current.pause();
        setIsPlaying(false);
      } catch (error) {
        console.error("Error stopping video:", error);
      }
    }
    setOpenModal(false);
  };

  const handleSave = () => {
    setLoading(true);

    const statusValue = status === "Active" ? 0 : 1;
    
    // Prepare the payload
    const userData = {
      username,
      mobile,
      email,
      Mob_Verify: mobileVerified,
      gender,
      Id_Verify: idVerified,
      accountType,
      accountFor,
      AskPayment: askPayment,
      IsPhoto: isPhotoVerified,
      IsVideo: isVideoVerified,
      isPhotoApproved,
      SetCV: setCv,
      userStatus: statusValue,
      // Only include inactiveReason if status is Deactive
      ...(status === "Deactive" && { inactiveReason }),
      Balance: balance,
      AffBalance: affBalance,
      Email_Verify: emailVerified,
      isCvApproved,
      promote,
      lock,
      IsAdmin: isAdmin,
      IsTeam: isTeam,
      OnlyAff: onlyAff,
      AdminType: adminType,
      UniqueId: uniqueId,
      AffLink: affLink,
      affiliateId,
      ExpoToken: expoToken,
      androidId,
      osName,
      osBuildId,
      source
    };

    AxiosUrl.post(`/update-user/${uid}/${data._id}`, userData)
      .then((res) => {
        setLoading(false);
        toast.success("User updated successfully!");
        setRefresh((prev) => prev + 1);
        setOpenModal(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        toast.error("Failed to update user");
      });
  };

  const getStatusColor = () => {
    return status === "Active" ? "#4caf50" : "#f44336";
  };

  const getAccountTypeColor = () => {
    if (accountType === "Premium") return "#ff9800";
    if (accountType === "VIP") return "#e91e63";
    if (accountType === "Islamic") return "#009688";
    return "#2196f3";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Asia/Dhaka'
    });
  };

  // Update video event handlers to handle errors
  const handleVideoTimeUpdate = () => {
    if (videoRef.current) {
      try {
        const minutes = Math.floor(videoRef.current.currentTime / 60);
        const seconds = Math.floor(videoRef.current.currentTime % 60);
        setVideoTime(`${minutes}:${seconds < 10 ? '0' + seconds : seconds}`);
        handleVideoProgress();
      } catch (error) {
        console.error("Error updating video time:", error);
      }
    }
  };

  // Update video progress with error handling
  const handleVideoProgress = () => {
    if (videoRef.current) {
      try {
        const percent = (videoRef.current.currentTime / videoRef.current.duration) * 100;
        setProgress(percent);
      } catch (error) {
        console.error("Error updating video progress:", error);
      }
    }
  };

  // Update the handlePlayVideo function to handle errors
  const handlePlayVideo = () => {
    if (videoRef.current) {
      try {
        if (isPlaying) {
          videoRef.current.pause();
        } else {
          const playPromise = videoRef.current.play();
          
          // Handle play promise to avoid DOMException
          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                // Playback started successfully
              })
              .catch(error => {
                console.error("Play error:", error);
                // Auto-play was prevented, show play UI
                setIsPlaying(false);
              });
          }
        }
        setIsPlaying(!isPlaying);
      } catch (error) {
        console.error("Error during video playback:", error);
      }
    }
  };

  const handleMuteVideo = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(!isMuted);
    }
  };

  const handleFullscreen = () => {
    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen();
      } else if (videoRef.current.webkitRequestFullscreen) {
        videoRef.current.webkitRequestFullscreen();
      } else if (videoRef.current.msRequestFullscreen) {
        videoRef.current.msRequestFullscreen();
      }
    }
  };

  // Color scheme for icons based on category
  const iconColors = {
    basic: "#2196f3",       // Blue for basic info
    verification: "#4caf50", // Green for verification
    status: "#ff9800",      // Orange for status
    financial: "#9c27b0",   // Purple for financial
    admin: "#e91e63",       // Pink for admin
    affiliate: "#ff5722",   // Deep orange for affiliate
    device: "#607d8b",      // Blue grey for device
  };

  // Add cleanup for video element
  React.useEffect(() => {
    return () => {
      // Clean up video resources when component unmounts
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.src = '';
        videoRef.current.load();
      }
    };
  }, []);

  // Update video element when data changes
  React.useEffect(() => {
    // Reset video state when new data is loaded
    setIsPlaying(false);
    setProgress(0);
    setVideoTime('0:00');
  }, [data]);

  // Update useEffect to properly fetch inactiveReason when data changes
  React.useEffect(() => {
    // Check for inactiveReason in data and set it appropriately
    if (data) {
      // Handle loading inactive reason from different possible data structures
      if (data.inactiveReason && typeof data.inactiveReason === 'object' && data.inactiveReason.reason) {
        setInactiveReason(data.inactiveReason.reason);
      } else if (data.inactiveReason && typeof data.inactiveReason === 'string') {
        setInactiveReason(data.inactiveReason);
      }

      // Update status based on userStatus
      setStatus(data.userStatus === 0 ? "Active" : "Deactive");
    }
  }, [data]);

  // Enhance the video error handler to provide more detailed error information
  const handleVideoError = (event) => {
    console.error("Video error:", event);
    // Get error details if available
    if (event.target && event.target.error) {
      const error = event.target.error;
      console.error(`Video error code: ${error.code}, message: ${error.message}`);
      
      // Display different messages based on error code
      switch (error.code) {
        case MediaError.MEDIA_ERR_ABORTED:
          console.error("Video playback aborted by the user");
          break;
        case MediaError.MEDIA_ERR_NETWORK:
          console.error("Network error occurred while loading the video");
          break;
        case MediaError.MEDIA_ERR_DECODE:
          console.error("Video decoding error");
          break;
        case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
          console.error("Video format not supported");
          break;
        default:
          console.error("Unknown video error");
      }
    }
    setIsPlaying(false);
  };

  return (
    <div>
      <ToastContainer />
      <Modal
        open={true}
        onClose={handleClose}
        aria-labelledby="update-user-modal-title"
        aria-describedby="update-user-modal-description"
      >
        <Box className={isMobile ? "user-modal-box user-modal-box-mobile" : "user-modal-box"}>
          <div className="user-modal-header">
            <h2 id="update-user-modal-title">
              <EditIcon style={{ marginRight: '8px', fontSize: '20px' }} />
              UPDATE USER
            </h2>
            <div className="user-modal-header-chips">
              <Chip 
                label={status} 
                size="small" 
                style={{ 
                  backgroundColor: getStatusColor(),
                  color: 'white',
                  fontWeight: 'bold',
                  marginRight: '8px'
                }} 
              />
              <Chip 
                label={accountType} 
                size="small" 
                style={{ 
                  backgroundColor: getAccountTypeColor(),
                  color: 'white',
                  fontWeight: 'bold'
                }} 
              />
            </div>
            <IconButton 
              aria-label="close" 
              onClick={handleClose}
              className="user-modal-close-btn"
            >
              <CloseIcon />
            </IconButton>
          </div>

          <div className="user-modal-info-bar">
            <div className="user-modal-info-item">
              <span className="user-modal-info-label">ID:</span>
              <span className="user-modal-info-value">{data._id}</span>
            </div>
            <div className="user-modal-info-item">
              <span className="user-modal-info-label">Created:</span>
              <span className="user-modal-info-value">{formatDate(data.createdAt)}</span>
            </div>
          </div>

          <div className="user-modal-media-preview">
            <div className="user-modal-photo-container">
              <img 
                src={data.photo || "https://ui-avatars.com/api/?name=" + username + "&background=0D8ABC&color=fff"} 
                alt={username} 
                className="user-modal-photo" 
              />
              {isPhotoVerified && (
                <div className="user-modal-photo-badge">
                  <CheckCircleIcon />
                </div>
              )}
            </div>
            <div className="user-modal-video-container">
              {data.video ? (
                <div className="user-modal-video-wrapper">
                  <video 
                    ref={videoRef}
                    className="user-modal-video"
                    poster={data.photo}
                    onTimeUpdate={handleVideoTimeUpdate}
                    onEnded={() => setIsPlaying(false)}
                    onError={handleVideoError}
                    onPause={() => setIsPlaying(false)}
                    muted={isMuted}
                    preload="metadata"
                    playsInline
                  >
                    <source src={data.video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <div 
                    className="user-modal-video-progress" 
                    style={{ width: `${progress}%` }}
                  ></div>
                  <div className="user-modal-video-controls">
                    <IconButton 
                      className="user-modal-video-play"
                      onClick={handlePlayVideo}
                    >
                      {isPlaying ? (
                        <PauseIcon />
                      ) : (
                        <PlayArrowIcon />
                      )}
                    </IconButton>
                    <div className="user-modal-video-time">{videoTime}</div>
                    <div className="user-modal-video-actions">
                      <IconButton 
                        size="small"
                        onClick={handleMuteVideo}
                      >
                        {isMuted ? (
                          <VolumeOffIcon fontSize="small" />
                        ) : (
                          <VolumeUpIcon fontSize="small" />
                        )}
                      </IconButton>
                      <IconButton 
                        size="small"
                        onClick={handleFullscreen}
                      >
                        <FullscreenIcon fontSize="small" />
                      </IconButton>
                    </div>
                  </div>
                  {isVideoVerified && (
                    <div className="user-modal-video-badge">
                      <CheckCircleIcon />
                    </div>
                  )}
                </div>
              ) : (
                <div className="user-modal-no-video">
                  <PlayArrowIcon className="user-modal-no-video-icon" />
                </div>
              )}
            </div>
          </div>

          <div className="user-modal-form">
            <div className="user-modal-section-divider">
              <h3>Basic Information</h3>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="username">Username</label>
                <TextField
                  id="username"
                  variant="outlined"
                  fullWidth
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  InputProps={{
                    startAdornment: <PersonIcon style={{ color: iconColors.basic, marginRight: '8px' }} />,
                    endAdornment: username && (
                      <IconButton 
                        size="small" 
                        onClick={() => setUsername("")}
                        className="user-modal-clear-input"
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    )
                  }}
                />
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="email">Email</label>
                <TextField
                  id="email"
                  variant="outlined"
                  fullWidth
                  value={email || ""}
                  onChange={(e) => setEmail(e.target.value)}
                  InputProps={{
                    startAdornment: <EmailIcon style={{ color: iconColors.basic, marginRight: '8px' }} />
                  }}
                />
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="mobile">Mobile</label>
                <TextField
                  id="mobile"
                  variant="outlined"
                  fullWidth
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  InputProps={{
                    startAdornment: <PhoneIcon style={{ color: iconColors.basic, marginRight: '8px' }} />
                  }}
                />
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="gender">Gender</label>
                <TextField
                  id="gender"
                  select
                  variant="outlined"
                  fullWidth
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  InputProps={{
                    startAdornment: <WcIcon style={{ color: iconColors.basic, marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="Male">Men</MenuItem>
                  <MenuItem value="Female">Women</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="account-for">Account For</label>
                <TextField
                  id="account-for"
                  select
                  variant="outlined"
                  fullWidth
                  value={accountFor}
                  onChange={(e) => setAccountFor(e.target.value)}
                  InputProps={{
                    startAdornment: <FamilyRestroomIcon style={{ color: iconColors.basic, marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="Self">Self</MenuItem>
                  <MenuItem value="Son">Son</MenuItem>
                  <MenuItem value="Daughter">Daughter</MenuItem>
                  <MenuItem value="Brother">Brother</MenuItem>
                  <MenuItem value="Sister">Sister</MenuItem>
                  <MenuItem value="Relative">Relative</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="account-type">Account Type</label>
                <TextField
                  id="account-type"
                  select
                  variant="outlined"
                  fullWidth
                  value={accountType}
                  onChange={(e) => setAccountType(e.target.value)}
                  InputProps={{
                    startAdornment: <CardMembershipIcon style={{ color: getAccountTypeColor(), marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="General">General</MenuItem>
                  <MenuItem value="Premium">Premium</MenuItem>
                  <MenuItem value="VIP">VIP</MenuItem>
                  <MenuItem value="Islamic">Islamic</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-section-divider">
              <h3>Verification Status</h3>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="mobile-verified">Mobile Verified</label>
                <TextField
                  id="mobile-verified"
                  select
                  variant="outlined"
                  fullWidth
                  value={mobileVerified ? "true" : "false"}
                  onChange={(e) => setMobileVerified(e.target.value === "true")}
                  InputProps={{
                    startAdornment: <VerifiedUserIcon style={{ color: mobileVerified ? iconColors.verification : '#999', marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="email-verified">Email Verified</label>
                <TextField
                  id="email-verified"
                  select
                  variant="outlined"
                  fullWidth
                  value={emailVerified ? "true" : "false"}
                  onChange={(e) => setEmailVerified(e.target.value === "true")}
                  InputProps={{
                    startAdornment: <EmailIcon style={{ color: emailVerified ? iconColors.verification : '#999', marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="id-verified">NID Verified</label>
                <TextField
                  id="id-verified"
                  select
                  variant="outlined"
                  fullWidth
                  value={idVerified ? "true" : "false"}
                  onChange={(e) => setIdVerified(e.target.value === "true")}
                  InputProps={{
                    startAdornment: <VerifiedUserIcon style={{ color: idVerified ? iconColors.verification : '#999', marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="photo-verified">Photo Verified</label>
                <TextField
                  id="photo-verified"
                  select
                  variant="outlined"
                  fullWidth
                  value={isPhotoVerified ? "true" : "false"}
                  onChange={(e) => setIsPhotoVerified(e.target.value === "true")}
                  InputProps={{
                    startAdornment: <PhotoCameraIcon style={{ color: isPhotoVerified ? iconColors.verification : '#999', marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="photo-approved">Photo Approved</label>
                <TextField
                  id="photo-approved"
                  select
                  variant="outlined"
                  fullWidth
                  value={isPhotoApproved ? "true" : "false"}
                  onChange={(e) => setIsPhotoApproved(e.target.value === "true")}
                  InputProps={{
                    startAdornment: <CheckCircleIcon style={{ color: isPhotoApproved ? iconColors.verification : '#999', marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="video-verified">Video Verified</label>
                <TextField
                  id="video-verified"
                  select
                  variant="outlined"
                  fullWidth
                  value={isVideoVerified ? "true" : "false"}
                  onChange={(e) => setIsVideoVerified(e.target.value === "true")}
                  InputProps={{
                    startAdornment: <VideocamIcon style={{ color: isVideoVerified ? iconColors.verification : '#999', marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="set-cv">CV Set</label>
                <TextField
                  id="set-cv"
                  select
                  variant="outlined"
                  fullWidth
                  value={setCv ? "true" : "false"}
                  onChange={(e) => setSetCv(e.target.value === "true")}
                  InputProps={{
                    startAdornment: <DescriptionIcon style={{ color: setCv ? iconColors.verification : '#999', marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="cv-approved">CV Approved</label>
                <TextField
                  id="cv-approved"
                  select
                  variant="outlined"
                  fullWidth
                  value={isCvApproved ? "true" : "false"}
                  onChange={(e) => setIsCvApproved(e.target.value === "true")}
                  InputProps={{
                    startAdornment: <DescriptionIcon style={{ color: isCvApproved ? iconColors.verification : '#999', marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-section-divider">
              <h3>Account Status</h3>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="status">Account Status</label>
                <TextField
                  id="status"
                  select
                  variant="outlined"
                  fullWidth
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  InputProps={{
                    startAdornment: <ToggleOnIcon style={{ color: getStatusColor(), marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Deactive">Deactive</MenuItem>
                </TextField>
              </div>
            </div>

            {status === "Deactive" && (
              <div className="user-modal-form-row" style={{ width: '100%' }}>
                <div className="user-modal-form-group deactivation-reason-group">
                  <label htmlFor="inactive-reason">
                    Deactivation Reason
                    {inactiveReason && (
                      <span className="current-reason-label">Current Reason</span>
                    )}
                  </label>
                  <TextField
                    id="inactive-reason"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={3}
                    value={inactiveReason || ""}
                    onChange={(e) => setInactiveReason(e.target.value)}
                    placeholder="Please provide a reason for deactivating this account"
                    InputProps={{
                      startAdornment: <BlockIcon style={{ color: '#f44336', marginRight: '8px', alignSelf: 'flex-start', marginTop: '10px' }} />,
                      className: "deactivation-reason-input"
                    }}
                  />
                  <div className="deactivation-notice">
                    <p>This reason will be stored with the account record and may be displayed to the user.</p>
                  </div>
                </div>
              </div>
            )}

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="lock">Account Lock</label>
                <TextField
                  id="lock"
                  select
                  variant="outlined"
                  fullWidth
                  value={lock ? "true" : "false"}
                  onChange={(e) => setLock(e.target.value === "true")}
                  InputProps={{
                    startAdornment: <LockIcon style={{ color: lock ? "#f44336" : '#999', marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="ask-payment">Ask Payment</label>
                <TextField
                  id="ask-payment"
                  select
                  variant="outlined"
                  fullWidth
                  value={askPayment ? "true" : "false"}
                  onChange={(e) => setAskPayment(e.target.value === "true")}
                  InputProps={{
                    startAdornment: <PaymentIcon style={{ color: askPayment ? iconColors.status : '#999', marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="promote">Promote User</label>
                <TextField
                  id="promote"
                  select
                  variant="outlined"
                  fullWidth
                  value={promote ? "true" : "false"}
                  onChange={(e) => setPromote(e.target.value === "true")}
                  InputProps={{
                    startAdornment: <CampaignIcon style={{ color: promote ? iconColors.status : '#999', marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-section-divider">
              <h3>Financial Information</h3>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="balance">Balance</label>
                <TextField
                  id="balance"
                  variant="outlined"
                  fullWidth
                  type="number"
                  value={balance}
                  onChange={(e) => setBalance(Number(e.target.value))}
                  InputProps={{
                    startAdornment: <AccountBalanceWalletIcon style={{ color: iconColors.financial, marginRight: '8px' }} />
                  }}
                />
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="aff-balance">Affiliate Balance</label>
                <TextField
                  id="aff-balance"
                  variant="outlined"
                  fullWidth
                  type="number"
                  value={affBalance}
                  onChange={(e) => setAffBalance(Number(e.target.value))}
                  InputProps={{
                    startAdornment: <MoneyIcon style={{ color: iconColors.financial, marginRight: '8px' }} />
                  }}
                />
              </div>
            </div>

            <div className="user-modal-section-divider">
              <h3>Administrative Information</h3>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="is-admin">Is Admin</label>
                <TextField
                  id="is-admin"
                  select
                  variant="outlined"
                  fullWidth
                  value={isAdmin ? "true" : "false"}
                  onChange={(e) => setIsAdmin(e.target.value === "true")}
                  InputProps={{
                    startAdornment: <AdminPanelSettingsIcon style={{ color: isAdmin ? iconColors.admin : '#999', marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </TextField>
              </div>
            </div>

            {isAdmin && (
              <div className="user-modal-form-row">
                <div className="user-modal-form-group">
                  <label htmlFor="admin-type">Admin Type</label>
                  <TextField
                    id="admin-type"
                    variant="outlined"
                    fullWidth
                    value={adminType}
                    onChange={(e) => setAdminType(e.target.value)}
                    InputProps={{
                      startAdornment: <AdminPanelSettingsIcon style={{ color: iconColors.admin, marginRight: '8px' }} />
                    }}
                  />
                </div>
              </div>
            )}

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="is-team">Is Team Member</label>
                <TextField
                  id="is-team"
                  select
                  variant="outlined"
                  fullWidth
                  value={isTeam ? "true" : "false"}
                  onChange={(e) => setIsTeam(e.target.value === "true")}
                  InputProps={{
                    startAdornment: <GroupsIcon style={{ color: isTeam ? iconColors.admin : '#999', marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-section-divider">
              <h3>Affiliate Information</h3>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="only-aff">Only Affiliate</label>
                <TextField
                  id="only-aff"
                  select
                  variant="outlined"
                  fullWidth
                  value={onlyAff ? "true" : "false"}
                  onChange={(e) => setOnlyAff(e.target.value === "true")}
                  InputProps={{
                    startAdornment: <LoyaltyIcon style={{ color: onlyAff ? iconColors.affiliate : '#999', marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </TextField>
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="unique-id">Unique ID</label>
                <TextField
                  id="unique-id"
                  variant="outlined"
                  fullWidth
                  value={uniqueId || ""}
                  onChange={(e) => setUniqueId(e.target.value)}
                  InputProps={{
                    startAdornment: <PersonIcon style={{ color: iconColors.affiliate, marginRight: '8px' }} />
                  }}
                />
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="aff-link">Affiliate Link</label>
                <TextField
                  id="aff-link"
                  variant="outlined"
                  fullWidth
                  value={affLink || ""}
                  onChange={(e) => setAffLink(e.target.value)}
                  InputProps={{
                    startAdornment: <LinkIcon style={{ color: iconColors.affiliate, marginRight: '8px' }} />
                  }}
                />
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="affiliate-id">Affiliate ID</label>
                <TextField
                  id="affiliate-id"
                  variant="outlined"
                  fullWidth
                  value={affiliateId || ""}
                  onChange={(e) => setAffiliateId(e.target.value)}
                  InputProps={{
                    startAdornment: <LoyaltyIcon style={{ color: iconColors.affiliate, marginRight: '8px' }} />
                  }}
                />
              </div>
            </div>

            <div className="user-modal-section-divider">
              <h3>Device Information</h3>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="expo-token">Expo Token</label>
                <TextField
                  id="expo-token"
                  variant="outlined"
                  fullWidth
                  value={expoToken || ""}
                  onChange={(e) => setExpoToken(e.target.value)}
                  InputProps={{
                    startAdornment: <DevicesIcon style={{ color: iconColors.device, marginRight: '8px' }} />
                  }}
                />
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="android-id">Android ID</label>
                <TextField
                  id="android-id"
                  variant="outlined"
                  fullWidth
                  value={androidId || ""}
                  onChange={(e) => setAndroidId(e.target.value)}
                  InputProps={{
                    startAdornment: <AndroidIcon style={{ color: iconColors.device, marginRight: '8px' }} />
                  }}
                />
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="os-name">OS Name</label>
                <TextField
                  id="os-name"
                  variant="outlined"
                  fullWidth
                  value={osName || ""}
                  onChange={(e) => setOsName(e.target.value)}
                  InputProps={{
                    startAdornment: <DevicesIcon style={{ color: iconColors.device, marginRight: '8px' }} />
                  }}
                />
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="os-build">OS Build ID</label>
                <TextField
                  id="os-build"
                  variant="outlined"
                  fullWidth
                  value={osBuildId || ""}
                  onChange={(e) => setOsBuildId(e.target.value)}
                  InputProps={{
                    startAdornment: <DevicesIcon style={{ color: iconColors.device, marginRight: '8px' }} />
                  }}
                />
              </div>
            </div>

            <div className="user-modal-form-row">
              <div className="user-modal-form-group">
                <label htmlFor="source">Signup Source</label>
                <TextField
                  id="source"
                  select
                  variant="outlined"
                  fullWidth
                  value={source || ""}
                  onChange={(e) => setSource(e.target.value)}
                  InputProps={{
                    startAdornment: <CampaignIcon style={{ color: iconColors.device, marginRight: '8px' }} />
                  }}
                >
                  <MenuItem value="">None</MenuItem>
                  <MenuItem value="direct">Direct</MenuItem>
                  <MenuItem value="facebook">Facebook</MenuItem>
                  <MenuItem value="google">Google</MenuItem>
                  <MenuItem value="instagram">Instagram</MenuItem>
                  <MenuItem value="twitter">Twitter</MenuItem>
                  <MenuItem value="youtube">YouTube</MenuItem>
                  <MenuItem value="linkedin">LinkedIn</MenuItem>
                  <MenuItem value="organic">Organic</MenuItem>
                  <MenuItem value="affiliate">Affiliate</MenuItem>
                  <MenuItem value="referral">Referral</MenuItem>
                </TextField>
              </div>
            </div>
          </div>

          <div className="user-modal-actions">
            <Button 
              variant="outlined" 
              className="user-modal-close-button"
              onClick={handleClose}
              startIcon={<CloseIcon />}
            >
              CLOSE
            </Button>
            <Button 
              variant="contained" 
              className="user-modal-update-btn"
              onClick={handleSave}
              disabled={loading}
              startIcon={<EditIcon />}
            >
              {loading ? "UPDATING..." : "UPDATE USER"}
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default UpdateUser; 